module.exports = __webpack_public_path__ + "img/empty_featured_challenge.3f100032.jpg";